import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}

	.controls {
		display: flex;
		flex-direction: row;
		flex: 0 0 auto;
		border-bottom: 1px solid var(--og-border-color);
	}

	/* toolbars shrink with the editor and scroll their items instead of overflowing */
	.controls > og-toolbar {
		flex: 0 1 auto;
		min-width: 0;
	}

	.controls > .spacer {
		flex: 1 1 auto;
	}

	.body {
		flex: 1;
		overflow: hidden;
	}

	og-splitcontainer {
		height: 100%;
	}
`;

/**
 * The right panel is mounted inside the split container's shadow root, out
 * of reach of the host styles above - it carries its own sheet.
 */
export const panelStyle = css`
	.panel {
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;
	}

	.panel .names {
		display: grid;
		grid-template-columns: auto 1fr;
		gap: 4px;
		align-items: center;
		flex: 0 0 auto;
		padding: 4px;
		font-size: 11px;
		color: var(--og-text-color-3);
		border-bottom: 1px solid var(--og-border-color);
	}

	.panel .names label {
		opacity: .7;
	}

	.panel .names og-input {
		border: 1px solid var(--og-colortype-accent-border-color);
		color: var(--og-text-color-3);
	}

	.panel .panel-body {
		flex: 1;
		overflow: hidden;
		padding: 4px;
	}

	.panel .panel-body > * {
		height: 100%;
	}
`;
